import React, { useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@material-ui/core/AppBar';
// import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import MenuSharpIcon from '@material-ui/icons/MenuSharp';
import MenuOpenSharpIcon from '@material-ui/icons/MenuOpenSharp';
import CustomButton from './viewEventUi/CustomButton';
import DropDown from './dropDown';
import AccountCircleSharpIcon from '@material-ui/icons/AccountCircleSharp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
// import { primaryBlue } from '../constants/index';
import { topAndBottomBarColor } from '../constants/colorsCustom';
import CustomPopover from './customPopover';

const useStyles = makeStyles((theme) => ({
  root: {
    // flexGrow: 1,
    paddingBottom: theme.spacing(3),
  },
  appBar: {
    display: 'flex',
    // flex: 1,
    // flexGrow: 1,
    backgroundColor: topAndBottomBarColor,
    // boxShadow: "0px 0px 0px 0px ",
    zIndex: '1000',
    // borderRadius: "0px 0px 10px 10px",
    height: '58px',
  },
  parentContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
  },
  leftContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 0.3,
    [theme.breakpoints.down('md')]: {
      flex: 0.2,
    },
    [theme.breakpoints.up('md')]: {
      flex: 0.3,
    },
  },
  centerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    flex: 0.4,
    // display: 'block',
    // [theme.breakpoints.down('sm')]: {
    //   display: 'none',
    // },
    // [theme.breakpoints.up('sm')]: {
    //   display: 'flex',
    // },
    [theme.breakpoints.down('md')]: {
      flex: 0.6,
      display: 'none',
    },
    [theme.breakpoints.up('md')]: {
      flex: 0.4,
      display: 'flex',
    },
    // [theme.breakpoints.down("lg")]: {
    //   flex: 0.4,
    // },
  },
  rightContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flex: 0.3,
    // [theme.breakpoints.up("sm")]: {
    //   flex: 0.2,
    // },
    // [theme.breakpoints.down("lg")]: {
    //   flex: 0.3,
    // },
    [theme.breakpoints.down('md')]: {
      flex: 0.1,
    },
    [theme.breakpoints.up('md')]: {
      flex: 0.3,
    },
  },
  tabUnSelected: {},
  tabSelected: {
    color: '#fff',
    borderBottom: 'solid 3px #63C5DA',
    borderRadius: 0,
    margin: 0,
    padding: 16,
  },
  typography: {
    padding: theme.spacing(2),
    color: 'blue',
    cursor: 'pointer',
  },
  title: {
    // flexGrow: 1,
  },
  myAccount: {
    textTransform: 'none',
    width: theme.spacing(10),
  },
  square: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    backgroundColor: '#fff', //191838 --old
    marginRight: theme.spacing(1),
    borderRadius: theme.spacing(0.5),
    cursor: 'pointer',
  },
  logo: {
    objectFit: 'cover',
    overflow: 'hidden',
  },
  greenBtn: {
    color: '#fff', //D1373F
    backgroundColor: '#008000',
    borderColor: '#008000',
    height: theme.spacing(3.8),
    borderWidth: theme.spacing(0.2),
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    width: theme.spacing(14),
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(10),
    },
    '&:hover': {
      backgroundColor: '#008000',
      borderColor: '#00acc1',
    },
  },
  textTransform: {
    textTransform: 'none',
    color: '#fff',
    display: 'block',
    fontSize: '0.875rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '0.875rem',
    },
    [theme.breakpoints.down('400')]: {
      // fontSize: '0px'
      display: 'none',
    },
  },
  menuClosed: {
    fill: '#fff',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  signinBtn: {
    border: 'none',
    color: '#000000',
    margin: '0px',
    padding: '0px',
    textTransform: 'none',
  },
}));

//example props
// const title = "TOGETHER";

// const data = [
//   { type: "normal", display: "HOME" },
//   { type: "normal", display: "ABOUT US" },
//   { type: "normal", display: "EVENTS" },
//   { type: "normal", display: "CONTACT US" },
//   { type: "icon", display: "Myaccount" },
//   {
//     type: "auth",
//     display: "signup",
//   },
//   { type: "auth", display: "login" },
// ];

const TopAppBar = (props) => {
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();
  const title = props.title;
  const data = props.data;
  const centerData = props.centerData;
  const sidebarOpen = props.sidebarOpen;
  const setSideBarOpen = props.setSideBarOpen;
  const userType = props.userType;
  const elRefRen = useRef(null);

  const [anchorEl, setAnchorEl] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(true);
  };

  const handleClose = () => {
    setAnchorEl(false);
  };

  return (
    <div className={classes.root}>
      <AppBar position='relative' color='secondary' className={classes.appBar}>
        <div className={classes.parentContainer}>
          <div className={classes.leftContainer}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {userType === 3 || !userType ? null : sidebarOpen ? (
                <IconButton onClick={() => setSideBarOpen(false)}>
                  <MenuOpenSharpIcon className={classes.menuClosed} />
                </IconButton>
              ) : (
                <IconButton onClick={() => setSideBarOpen(true)}>
                  <MenuSharpIcon
                    color='primary'
                    className={classes.menuClosed}
                  />
                </IconButton>
              )}
              <Avatar
                onClick={() => history.push('/')}
                variant='square'
                alt='logo'
                className={classes.square}
              >
                <img src={props.logo} className={classes.logo} alt='' />
              </Avatar>

              <Typography
                variant='h6'
                onClick={() => history.push('/')}
                className={classes.title}
                style={{ color: '#fff', cursor: 'pointer' }}
              >
                {title}
              </Typography>
            </div>
          </div>

          <div className={classes.centerContainer}>
            {centerData.map((data) => {
              if (userType == 3) {
                return null;
              } else if (userType == 2) {
                return null;
              } else if (userType == 1) {
                const isSelectedTab =
                  data.url == location.pathname ? true : false;
                const styleClass = isSelectedTab
                  ? classes.tabSelected
                  : classes.tabUnSelected;
                return (
                  <Button
                    color='inherit'
                    disableRipple
                    component='span'
                    onClick={() => history.push(data.url)}
                    className={styleClass}
                  >
                    <Typography
                      variant='button'
                      className={classes.textTransform}
                    >
                      {data.display}
                    </Typography>
                  </Button>
                );
              }
            })}
          </div>

          <div className={classes.rightContainer}>
            {data.map((each, index) => {
              switch (each.type) {
                case 'normal':
                  return (
                    <Button
                      color='inherit'
                      disableRipple
                      component='span'
                      onClick={() => history.push(each.url)}
                      style={{ color: '#000' }}
                    >
                      <Typography
                        variant='button'
                        className={classes.textTransform}
                      >
                        {each.display}
                      </Typography>
                    </Button>
                  );
                case 'host':
                  if (userType == 2) {
                    return (
                      <Button
                        color='inherit'
                        disableRipple
                        component='span'
                        onClick={() => history.push(each.url)}
                        style={{ color: '#000' }}
                      >
                        <Typography
                          variant='button'
                          className={classes.textTransform}
                        >
                          {each.display}
                        </Typography>
                      </Button>
                    );
                  } else {
                    return null;
                  }
                case 'iconProfile':
                  return (
                    <div ref={elRefRen} key={index}>
                      <Button
                        disableRipple
                        component='span'
                        onClick={handleClick}
                        key={index}
                        style={{ color: '#fff' }}
                      >
                        <AccountCircleSharpIcon />
                        <ArrowDropDownIcon />
                      </Button>

                      <CustomPopover
                        open={anchorEl}
                        handleClose={handleClose}
                        elRefRen={elRefRen}
                      >
                        <DropDown />
                      </CustomPopover>
                    </div>
                  );
                case 'auth':
                  return (
                    <CustomButton
                      key={index}
                      btnStyle={classes.greenBtn}
                      clickHandle={() => history.push(each.url)}
                      btnText={each.display}
                    />
                  );

                // case 'special':
                //   return (
                //     <CustomButton
                //       key={index}
                //       // btnStyle={classes.greenBtn}
                //       btnStyle={classes.signinBtn}
                //       clickHandle={each.func}
                //       btnText={each.display}
                //     />
                //   );

                default:
                  return null;
              }
            })}
          </div>
        </div>
      </AppBar>
    </div>
  );
};

export default TopAppBar;
